import { gql } from '../../__generated__';
import gqlTag from 'graphql-tag';

const LicenseModelItem = gql(`
  fragment LicenseModelItem2 on LicenseModel {
    id
    bksId
    pendingTermination
    discounts
  }
`);

const LicenseItem = gql(`
  fragment LicenseItem2 on License {
    id
    companyName
    orgNumber
    isActive
    isLocked
    maconomy {
      customerNumber
    }
    contact {
      id
      displayName
    }
    createdAt
  }
`);

export const GET_LICENSES = gqlTag(`
  query GetLicenses(
    $page: Int!
    $pageSize: Int!
    $searchTerm: String
    $series: Int
    $onlyActive: Boolean
    $onlyLocked: Boolean
    $onlyADFS: Boolean
    $onlyPendTerm: Boolean
    $onlyInformed: Boolean
    $getColumn: [String]
    $enableDateFilter: Boolean
    $fromDate: DateTime
    $toDate: DateTime
  ) {
    licenses: allLicenses(
      page: $page
      pageSize: $pageSize
      searchTerm: $searchTerm
      series: $series
      onlyActive: $onlyActive
      onlyLocked: $onlyLocked
      onlyPendTerm: $onlyPendTerm
      onlyADFS: $onlyADFS
      onlyInformed: $onlyInformed
      getColumn: $getColumn
      enableDateFilter: $enableDateFilter
      fromDate: $fromDate
      toDate: $toDate
    ) {
      licenses {
        id
        companyName
        orgNumber
        customerNumber
        administrator
        isGodkjentVaatromsbedrift
        isDeleted
        createdAt
        address {
          address1
          address2
          postalCode
          city
          country
        }
        invoiceRef
        subscriptions
        usersPerSubscriptions {
          subscriptionId
          numberOfUsers
        }
        licensesPerSubscription {
          subscriptionId
          numberOfUsers
        }
        code
        codeName
        numberOfEmployees
        totalPageViews
        lockedAt
        adminEmail
      }
      count
      page
      pageSize
    }
  }
`);

export const GET_LICENSES_EXPORT = gqlTag(`
  query ExportLicenses(
    $searchTerm: String
    $series: Int
    $onlyActive: Boolean
    $onlyLocked: Boolean
    $onlyADFS: Boolean
    $onlyPendTerm: Boolean
    $onlyInformed: Boolean
    $getColumn: [String]
    $enableDateFilter: Boolean
    $fromDate: DateTime
    $toDate: DateTime
  ) {
    licenses: allLicensesExport(
      searchTerm: $searchTerm
      series: $series
      onlyActive: $onlyActive
      onlyLocked: $onlyLocked
      onlyPendTerm: $onlyPendTerm
      onlyADFS: $onlyADFS
      onlyInformed: $onlyInformed
      getColumn: $getColumn
      enableDateFilter: $enableDateFilter
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
      companyName
      orgNumber
      customerNumber
      administrator
      isGodkjentVaatromsbedrift
      isDeleted
      createdAt
      address {
        address1
        address2
        postalCode
        city
        country
      }
      invoiceRef
      subscriptions
      usersPerSubscriptions {
        subscriptionId
        numberOfUsers
      }
      licensesPerSubscription {
        subscriptionId
        numberOfUsers
      }
      code
      codeName
      numberOfEmployees
      totalPageViews
      lockedAt
      adminEmail
    }
  }
`);

export const CREATE_LICENSE = gql(`
  mutation CreateLicense($input: CreateLicenseInput!) {
    createLicense(input: $input) {
      bksLicense {
        ...LicenseItem2
      }
      license {
        ...LicenseModelItem2
      }
    }
  }
`);

export const ALL_SUBSCRIPTIONS = gql(`
  query AllSubscriptions {
    subscriptions: allSubscriptions(onlyPaid: true) {
      id
      name
      number
      parentId
    }
  }
`);
